import { type PresetName } from '../../core';
import { isBuiltinPreset } from './customPresets';

/**
 * Parse a `?qc=<preset>` deep link (e.g. `/app/?qc=netflix-latin`), so a
 * marketing/guide page can open Studio with a QC preset preselected
 * (cue-forge-kjc.7). Only a known BUILT-IN preset id is actionable — a
 * `custom:<uuid>` id is device-local and can never resolve on a fresh visit, so
 * it (like any unknown id) is silently ignored rather than surfaced as an
 * error. This never triggers a run: QC still requires a loaded file.
 */
export function parseQcParam(search: string): PresetName | undefined {
  const raw = new URLSearchParams(search).get('qc');
  if (raw == null) return undefined;
  const id = raw.toLowerCase();
  return isBuiltinPreset(id) ? id : undefined;
}
